import { render, staticRenderFns } from "./global-details-popup.vue?vue&type=template&id=5db3c12c"
import script from "./global-details-popup.vue?vue&type=script&lang=js"
export * from "./global-details-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports